/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
export const lang ={
    Container:"箱",
     Cbm:"立方米",
      Weight:"重量",
  Balance:"结余",
  ThisYear:"今年",
  LastYear:"上年",
  Privacy_Policy:"隐私协议",
  Agree:"同意",
  user_name_not_exists:"用户名不存在",
  password_wrong:"密码错误",
    Please_set_materialtype_in_product_page:"请先到商品页面修改设置每一个商品的物料类型：成品-半成品-配件",
    deleteAccount:"注销账号",
    deleteAccountWillDeleteAllData:"注销账号将会删除所有数据并无法登录",
    backupDatabase:"备份数据库",
    restoreDatabase:"恢复数据库",
    materialtype:"物料类型",
    Manufacturing:"制造业版",
    Professional:"专业版",
    Standard:"标准版",
    product:"成品",
    halfProduct:"半成品",
    components:"配件",
    Parent:"父组件",
    Children:"子配件",
    Level:"层级",
    Timing:"计时",
    PieceCount:"计件",
    Wages:"工价",
    InternalProcess:"内部工序",
    ExternalProcess:"外部工序",
    ProceName:"工序名称",
    ProceIndex:"执行顺序",
    ChargeMan:"负责人",
    BillMethod:"计费方式",
    ConsumTime:"工时",
    Accessories:"配件",
    Assembly:"组装",
    materials:"物料",
    task:"任务",
    process:"工序",
    BOM:"BOM",
    Production:"生产",
    RestorePurchaseOneUse:"恢复购买",
    buy_fail_try_again:"请重新点击购买",
    Export:'导出',
    Date:"日期",
    BankDetail:"银行详细信息",
    Seller:"卖方",
    Buver:"买方",
    Currency:"货币",
    CompanyName:"公司名",
    ProformaInvoice:"形式发票",
    Discount:"折扣",
    PayStatus:"支付状态",
    ShippingStatus:"货运状态",
    FreightType:"运输类型",
    Shipping:"货运",
    Payment:"付款",
    Moneyname:"货币名",
	Tax:"税费",
	Freight:"货运费",
	Insurance:"保险费",
	Bankfee:"银行费用",
	Qc:"质量认证",
	Exchangerate:"汇率",
    Shippingnumber:"发货单号",
	ShipDate:"发货日期",
	Arrivedate:"到达日期",
	Grossweight:"毛重",
	CubicWeight:"立方重量",
	Totalpackages:"总包数",
    Moneytype:"货币类型",
	Quotedate :"报价日期",
	Validitydate:"有效日期",
	Paymentterm:"付款期限",
	Priceterm:"价格条款",
	DeliveryTerm:"交货期限",
    BankName:"银行名称",
	BankAddress:"银行地址",
	SwiftCode:"银行代码",
    Review:"审核",
    Signfor:"签收",
    Finance:"财务",
    Receiver:"收货人",
    Business:"业务",
    ContactPerson:'联系人',
    Profit:"利润",
    Staff_must_use_in_browser_please_check_the_address_in_help_page:'员工必须在谷歌浏览器内使用，请在主服务电脑APP上帮助页面查看ip地址，然后在其它电脑浏览器网址栏目输入该地址打开登录',
    newPassword:'新密码',
    ForgetPassword:'忘记密码',
    ContactUs:'联系我们/提建议',
    Actualpay_should_big_then_shouldpay:'实收不能大于应收',
    ShopAddress:'我的店铺地址 扫码下单',
    Submit:'提交',
    All:'全部',
    OrdernumExists:'订单号已经存在',
    PermissionDenied:'没有权限',
    StockTransfer:'库存调拨',
    FromWarehouse:'转出仓库',
    ToWarehouse:'转入仓库',
    PleaseUseInWebBrowser:'请在谷歌浏览器内使用导出Excel功能',
    PleasePrintInWebBrowser:'请在谷歌浏览器内使用打印功能',
    HistoryPrice:'历史价格',
    SerialNumber:'序列号',
    Please_Use_In_APP:'请在电脑软件内使用',
    Please_Purchase_In_APP:'请在APP内购买，不要在浏览器内购买',
    Connect_Postgresql_database_Default_database_is_sqlite_in_local:'可以连接Postgresql数据库,你的数据将会存储到Postgresql数据库,默认使用不需要连接Postgresql数据库,默认的是本地的Sqlite数据库',
    Connect_Postgresql_database_data_will_store_in_Postgresql:'连接Postgresql数据库,你的数据将会存储到Postgresql数据库,数据重新读取',
    Use_sqlite_data_will_store_in_local:'使用sqlite,数据会存储到本地机器',
    UsePostgresqlDatabase:'使用PGSQL数据库',
    UseSqliteDatabase:'使用Sqlite数据库',
    DatabaseName:'数据库名称',
    Test_connect:'测试连接',
    If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:'如果商品有颜色尺码，初始库存请填写0，添加商品后在进货里录入库存',
    my:'我的',
    my_shop_qrcode_scan:'我的店铺二维码，提供给客户扫码下单，客户手机要跟你的电脑连接同一个路由器',
    ip:'IP',
    port:'Port',
    orderstatus:'订单状态',
 image:'图片',
    Template:'模板',
    Please_select_a_excel_file:'请选择一个文件' ,
    Please_select_only_one_excel_file:'只能选择一个文件',
    Connect_Internet_Login_again:'连接互联网再登录一次再购买',
productHasValidDate:'我的产品有有效期',
productHasColor:'我的产品有颜色尺码',
GeneralGoods:'普通商品',
Selected:'已选择',
RestorePurchase:'恢复购买',
VerifyPurchase:'验证购买',
Buy_ElinkInvoice_one_year_use:'购买ERP企业版一年使用权,不限用户和设备数量（订阅）',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'购买ERP企业版1用户,一年（非订阅）',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'购买ERP企业版不限用户和设备数量,一次性永久（非订阅）',
Purchasing:'请耐心等待...',
Validdate:'有效期',
Makedate:'生产日期',
Batch:'批次',
CheckVersion:'检查版本',
Please_set_this_ip_address_on_App:'请在APP上设置这个IP地址,或者电脑的IP地址',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'在电脑或手机的谷歌浏览器打开这个连接(连接同一个WiFi)',
Etit_on_top_field:'请在上方的输入框修改订单信息',

    You_need_to_purchase:'你还没有购买,请登录再检测,或请加微信联系 Elink9988  邮箱:bvbuy@qq.com，如已经购买请忽视此提示',
    Thank_for_your_purchase:'你已经购买',
    New_version_available:'有新的版本',
    Is_the_latest_version:'是最新的版本',
please:'请',
input:'输入',
wrong:'错误',
Verifycode:'验证码',
You_need_to_purchase_to_continue_use:'你需要购买才能继续使用，如果已经购买,请点击恢复购买或验证购买，如已经购买请忽视此提示,或重启软件',
Upload:'上传',
Download:'下载',
CheckBuy:'检测购买',
Exists:'已经存在',
NetworkUnavailable:'网络不可用',
Today:'今天',
Yesterday:'昨天',
ThisMonth:'本月',
LastMonth:'上月',
nickname:'姓名',
storeName:'公司名',
CompanyInfo:'公司信息',
BuyStandAlone:'购买单机版',
PermissionDenied:'没有权限',
Boss:'管理员',
Chart:'图表',
login:'登录',
register:'注册',
User:'用户',
LoginName:'登录名',
username:'用户名',
password:'密码',
 ok:'确定',
cancel:'取消',
operate:'操作',
add:'新增',
edit:'修改',
success:'成功',
fail:'失败',
delete:'删除',
refresh:'刷新',
 close:'取消',
back:'返回',
ElinkInvoice:'移联ERP',
Purchase :' 进货',
BaseData :' 基础数据',
Sell :'销售',
PurchaseReturns:'采购退货',
SellReturns:'销售退货',
transIn:"调入",
transOut:"调出",
Inventory:'库存',
Statistics:'统计',
Orders:'订单',
Order:'订单',
StockTransferIn:'库存调入',
StockRecall:'库存调出',
Customer:'客户',
Supplier:'供应商',
Warehouse:'仓库',
Color:'颜色',
Size:'尺码',
Category:'分类',
Category2:'分类2',
Product:'商品',
Account:'流水账',
AccountType:'流水账分类',
Staff:'员工',
typeone:'品类',
typetwo:'子品类',
ProductName:'品名',
Specification:'规格',
Barcode:'编号',
Buyprice:'采购价',
Sellprice:'销售价',
Wholesaleprice:'批发价',
Currentstock:'当前库存',
Unit:'单位',
Parameter:'参数',
Remark:'备注',
Supplier:'供应商',
Customer:'客户',
Staff:'员工',
Receivable:'应收',
Receipts:'实收',
Payable:'应付',
Paid:'实付',
Overdraft:'欠款',
Initstock:'初始库存',

DateDay:'日期',
Preferential:'优惠',
OrderNum:'单号',
Password:'密码',
UserName:'名称',
IdNum:'省份证号',
BirthDay:'生日',
SEX:'性别',
Female:'女',
Male:'男',
Name:'名称',
Address:'地址',
Phone:'电话',
Email:'邮箱',
CardNum:'银行卡号',
Price:'价格',
QTY:'数量',
Select:'请选择',
SupplierCategory:'供应商分类',
CustomerCategory:'客户分类',
Power:'权限',
Role:'角色',
save:'保存',
image:'图片',
search:'搜索',
Year:'年',
Month:'月',
Day:'日',
Total:'合计',
WorkReport:'工作报告',
Leave:'请假',
CheckIn:'签到',
Title:'标题',
News:'新闻',
Announcement:'公告',
Approval:'审批',
Tracking:'轨迹跟踪',
Bill:'流水账',
OrdersDetail:'订单明细',
Expense:'支出',
Income:'收入',
Userfor:'用途',
Amount:'金额',
SelectFile:'选择文件',
Content:'内容',
Cost:'金额',
ApprovalUser:'审核用户',
ApprovalStatus:'审核状态',
ApprovalRemark:'审核备注',
ApprovalDate:'审核日期',
SubmitDate:'提交日期',
Status:'状态',
FromDateTime:'开始时间',
ToDateTime:'结束时间',
Subject:'内容',
Latitude:'纬度',
Longitude:'经度',
Print:'打印',
DataTrans:'数据传输',
OA:'移动办公',
Setting:'设置',
Help:'帮助',
ScanOpenInPhone:'扫描在手机打开使用',
Building:'大楼',
Room:'房间',
HotelCheckIn:'入住',
CheckOut:'退房',
Hotel:'酒店',
Checkintime:'入住时间',
Checkouttime:'退房时间',
Deposit:'押金',
Cost:'费用',
RoomNum:'房号',
Rent:'房租',
costday:'缴费日期',
 rent:'租金',
 waternum:'水表读数',
 electricnum:'电表读数',
 gasnum:'煤气表读数',
 watercost:'水费',
 electriccost:'电费',
 gascost:'煤气费',
 cleaningcost:'清洁费',
 networkcost:'网络费',
 tvcost:'电视费',
 managecost:'管理费',
 othercost:'其它费用',
 totalcost:'总共',
 remark:'备注',
 addtime:'添加日期',
 OpenInBrowser:'在浏览器打开',
 InventoryProfit:'库存盘盈',
 InventoryLoss:'库存盘亏',
 Buy:'购买',
 Refresh:'刷新',
 Add:'添加',
 Search:'搜索',
 Records:'条',
}



// WEBPACK FOOTER //
// ./src/lang/cn.js